import { Snackbar } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import React, { Ref, useImperativeHandle, useState } from "react";
import { v4 as uuid } from "uuid";
import InternalMessageType from "./InternalMessageType.model";
import Message from "./Message";
import MessageType from "./MessageType.model";

export type MessageSnackbarRef = {
  queue: (text: string, type: MessageType, autoHide: boolean) => void;
  clear: () => void;
};

const MAX_STACK_SIZE = 5;

function MessageSnackbar(props: unknown, ref: Ref<MessageSnackbarRef> | undefined) {
  const [messages, setMessages] = useState<InternalMessageType[]>([]);

  const addMessage = (message: InternalMessageType) => {
    setMessages((prev) => [
      ...prev
        .reverse()
        .slice(0, MAX_STACK_SIZE - 1)
        .reverse(),
      message,
    ]);
  };

  const removeMessage = (messageId: string) => {
    setMessages((prev) => {
      const index = prev.map((message) => message.id).indexOf(messageId);
      if (index >= 0) {
        const copy = [...prev];
        copy.splice(index, 1);
        return copy;
      }
      return prev;
    });
  };

  useImperativeHandle(ref, () => ({
    queue: (text: string, type: MessageType, autoHide: boolean = true, duration?: number): void => {
      const id = uuid();
      addMessage({
        id,
        text,
        type,
        autoHide,
        duration,
      });
    },
    clear: () => {
      setMessages(() => []);
    },
  }));

  return (
    <Snackbar open={messages.length > 0}>
      <Box display="flex" flexDirection="column" alignItems="center">
        {messages.map((message) => (
          <Message key={message.id} message={message} removeMessage={removeMessage} />
        ))}
      </Box>
    </Snackbar>
  );
}

export default React.forwardRef(MessageSnackbar);
